import { NavigateFunction } from 'react-router-dom';
import { PAL_KNOWLEDGE_CONCEPTS } from '../../routeHandling/RoutesNomenclature';
import { AppDispatch } from '../../reduxStore/store';
import { setModuleRedirectionPath } from './reducer/pal.slice';

export const onChapterSelect = (
  navigate: NavigateFunction,
  dispatch: AppDispatch,
  external_module_id: string,
  pathName?: string
) => {
  if (pathName) {
    dispatch(setModuleRedirectionPath(pathName));
  }
  navigate(PAL_KNOWLEDGE_CONCEPTS + '/' + external_module_id);
};
